import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const requestLogin = async (email, password) => {
  const res = await axios.post(`${BASE_URL}/login`, {
    email,
    password
  });
  return res.data;
};

export const requestForgotPassword = async (email) => {
  const response = await axios.post(`${BASE_URL}/forgot-password`, { email });
  return response.data;
};

export const requestResetPassword = async (email, newPassword, token) => {
  const response = await axios.post(`${BASE_URL}/reset-password`, {
    email,
    newPassword,
    token,
  });
  return response.data;
};

export const verifyResetOtp = async (email, otp) => {
  const res = await axios.post(`${BASE_URL}/verify-reset-otp`, { email, otp });
  return res.data;
};